import { useCallback } from "react";
import { useObjectMemo } from "byzantine";
import { useNavigate } from "react-router-dom";
import { useWireTypeSelector } from "byzantine/src/dbbl/businessLogic/modules/internationalWires";

export const useFormContainer = () => {
  const { submitMethod, wireType, form } = useWireTypeSelector();

  const navigate = useNavigate();
  const onCancel = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onSubmitMethod = useCallback(async () => {
    await submitMethod();
  }, [submitMethod]);

  return useObjectMemo({
    wireType,
    onCancel,
    onSubmitMethod,
    form,
  });
};

export default useFormContainer;